var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUsMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fill: "#F4F4F4",
    fillRule: "evenod",
    height: 512,
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.75 17.528c0-.991-.589-1.943-1.679-2.686-1.371-.935-3.577-1.564-6.071-1.564s-4.7.629-6.071 1.564c-1.09.743-1.679 1.695-1.679 2.686v1.068c0 .385.153.754.425 1.026s.64.424 1.025.424h12.6c.385 0 .753-.152 1.025-.424s.425-.641.425-1.026z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.307 13.294c.496.216.942.458 1.328.722 1.41.961 2.115 2.229 2.115 3.512v1.068c0 .525-.168 1.032-.475 1.45h4.025c.385 0 .753-.152 1.025-.424s.425-.641.425-1.026v-1.068c0-.991-.589-1.943-1.679-2.686-1.371-.935-3.577-1.564-6.071-1.564-.234 0-.465.005-.693.016z "
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 8.204,
    r: 4.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.791 4.573c.903.943 1.459 2.223 1.459 3.631s-.556 2.687-1.459 3.63c.644.393 1.4.62 2.209.62 2.346 0 4.25-1.905 4.25-4.25 0-2.346-1.904-4.25-4.25-4.25-.809 0-1.565.226-2.209.619z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsMenu);
export default __webpack_public_path__ + "static/media/aboutUsMenu.d8dae35dc9f6ce136df9576fac0cf953.svg";
export { ForwardRef as ReactComponent };